export const QUERY__STAKES = 'stakes';
export const QUERY__USER_STAKES = 'user-stakes';
export const QUERY__EVENT_STAKES = 'event-stakes';
export const QUERY__POOL_STAKES = 'pool-stakes';
